import React, { useEffect, useState } from "react";
import IconButton from "@mui/material/IconButton";
import CancelIcon from "@mui/icons-material/Cancel";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { useFormik } from "formik";
import MenuItem from "@mui/material/MenuItem";
import * as yup from "yup";
import TextField from "@mui/material/TextField";
import ReCAPTCHA from "react-google-recaptcha";
import {
  getCategoryList,
  getCityList,
  getProductList,
  getStateList,
  googleCaptchaAPIKey,
  productEnquiries,
} from "./networkCalls";
import { useStateValue, actionTypes } from "./store";
import { baseURL } from "./networkCalls";
import { useCookies } from "react-cookie";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import RemoveOutlinedIcon from '@mui/icons-material/RemoveOutlined';
const promise = getCategoryList();

const StickySidebar = () => {
  const [showSocial, setShowSocial] = useState(false);
  const [catlist, setCatlist] = useState([]);
  const [cookie] = useCookies(["hondaCookiee"]);

  const [isLoading, setLoading] = useState(true);
  const [show, setShow] = useState(true);
  useEffect(() => {
    promise.then((data) => {
      setCatlist(data?.CategoryListArray);
      setLoading(false);
    });
    if (cookie?.hondaCookiee) {
      setShow(false);
    }
  }, [catlist]);
  const validationSchema = yup.object({
    likeTo: yup.string("Select Like to").required("Select Like to"),
    cname: yup.string("Enter your Name").required("Name is required"),
    email: yup
      .string("Enter your email")
      .email("Enter a valid email")
      .required("Enter your email"),
    mobile: yup
      .string("")
      //.notRequired()
      .required()
      .matches(/^[0-9]+$/, "Must be only digits")
      .min(10, "Enter 10 digit mobile number")
      .max(10, "Enter 10 digit mobile number"),
    comments: yup.string("").notRequired(),
  });

  const liketoOption = [
    {
      value: "Service",
      label: "Service",
    },
    {
      value: "Sales",
      label: "Sales",
    },
    {
      value: "Demo",
      label: "Demo",
    },
    {
      value: "OEMs",
      label: "OEMs",
    },
    {
      value: "Supplier",
      label: "Supplier",
    },
    {
      value: "Export",
      label: "Export",
    },
  ];

  const [{ token, huid }, dispatch] = useStateValue();
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  const [openEnq, setopenEnq] = React.useState(false);
  const handleOpenEnq = () => setopenEnq(true);
  const handleCloseEnq = () => setopenEnq(false);

  const [stateList, setStateList] = React.useState([]);
  const pullStateList = (value) => {
    var data = new FormData();
    data.append("countryId", "IND");
    getStateList(data).then((res) => {
      switch (res.data.status) {
        case 1:
          setStateList(res.data.stateList);
          return true;
        case 0:
          break;
        default:
          return;
      }
    });
  };
  const [state, setState] = useState("");
  const [stateName, setStateName] = useState("");
  const [cityList, setCityList] = React.useState([]);
  const pullCityList = (value) => {
    var data = new FormData();
    data.append("stateId", value);
    getCityList(data).then((res) => {
      switch (res.data.status) {
        case 1:
          setCityList(res.data.cityList);
          return true;
        case 0:
          break;
        default:
          return;
      }
    });
  };

  const stateChange = (e, value) => {
    setState(value?.id);
    pullCityList(value?.id);
    setStateName(value?.label);
  };
  const [city, setCity] = useState("");
  const cityChange = (e, value) => {
    setCity(value?.label);
  };

  const [service, setService] = useState("");
  const [modal, setModal] = useState("");
  const [productData, setProductData] = useState([]);
  const pcatHandle = (e, value) => {
    setService(value?.name);
    callApiProductData(value?.id);
  };
  const modalHandle = (e, value) => {
    setModal(value?.name);
  };

  const callApiProductData = (value) => {
    var data = new FormData();
    data.append("categoryId", value);
    data.append("all", "true");
    getProductList(data).then((res) => {
      switch (res.data.status) {
        case 1:
          setProductData(res.data?.ProductList);
          return true;
        case 0:
          break;
        default:
          return;
      }
    });
  };

  // capcha code
  const TEST_SITE_KEY = googleCaptchaAPIKey;
  const recaptchaRef = React.createRef();
  const [captchavalue, setCaptchavalue] = React.useState("");
  const onVerifyCaptcha = (captchavalue) => {
    setCaptchavalue(captchavalue);
  };
  // end capcha code
  const enabledbtn = captchavalue != "";
  const formik = useFormik({
    initialValues: {
      likeTo: "",
      cname: "",
      email: "",
      mobile: "",
      comments: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values, {resetForm}) => {
      var data = new FormData();
      data.append("category", service);
      data.append("model", modal);
      data.append("service", values.likeTo);
      data.append("name", values.cname);
      data.append("email", values.email);
      data.append("mobile", values.mobile);
      data.append("state", state);
      data.append("city", city);
      data.append("comments", values.comments);
      data.append('captcha', captchavalue);
      
      productEnquiries(data).then((res) => {
        switch (res.data.status) {
          case 1:
            //setResultData(res.data.ProductList);
            dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: "success" });
            dispatch({
              type: actionTypes.SET_MSGALERTDATA,
              value: res.data.msz,
            });
            resetForm();
            handleCloseEnq();
            dispatch({ type: actionTypes.SET_MSGALERT, value: true });
            return true;
          case 0:
            //setResultData(res.data.ProductList);
            break;
          default:
            return;
        }
      });
    },
  });

  useEffect(() => {
    pullStateList();
  }, []);
  return (
    <div className="sticky-sidebar right">
      <div className="sidebar-btn">
        <div className="text-white" onClick={handleOpenEnq}>
          <img src={`${baseURL}images/hondaapplogo.png`}  width={40} />
        </div>
      </div>
      <div className="sidebar-btn sidebar-group">
        {" "}
        <a
          href="tel:1800-11-2323"
          //   target="_blank"
          className="text-white ms-2 mb-4"
        >
          <img src={`${baseURL}images/phone.svg`} width={25} />
        </a>
        <a
          href="/service-network"
          //   target="_blank"
          className="text-white ms-2"
        >
          <img src={`${baseURL}images/location.svg`} width={25} />
        </a>
      </div>
       <div className={!showSocial ? "sidebar-btn":"sidebar-btns"} onClick={() => setShowSocial(!showSocial)}>
        {!showSocial ? <img src={`${baseURL}images/thumbs.svg`} width={25} /> : <RemoveOutlinedIcon/>}
      </div>

      {/* Social Icons Expand - Positioned Separately */}
      {showSocial && (
        <div className="sidebar-social right">
          <div className="social-btn">
            <a
            href="https://www.facebook.com/hondaindiapowerproductslimited/"
            target="_blank"
            className="text-white"
          >
            <img src={`${baseURL}images/facebook.svg`}  />
          </a>
          </div>
          <div className="social-btn">
             <a
            href="https://www.youtube.com/channel/UCw5zgVa0o9sqcwZxI8axfHw/"
            target="_blank"
            className="text-white ms-2"
          >
            <img src={`${baseURL}images/youtube.svg`}  />
          </a>
          </div>
          <div className="social-btn">
            <a
            href="https://www.instagram.com/hondaindiapowerproducts/"
            target="_blank"
            className="text-white ms-2"
          >
            <img src={`${baseURL}images/inta.svg`}  />
          </a>
          </div>
          <div className="social-btn">
            <a
            href="https://www.linkedin.com/company/honda-india-power-products-ltd/"
            target="_blank"
            className="text-white ms-2"
          >
            <img src={`${baseURL}images/linkedin.svg`} />
          </a>
          </div>
        </div>
      )}
     
      
      <Modal
        open={openEnq}
        // onClose={handleCloseProfile}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...style, width: { xs: 340, sm: 760 } }}>
          <IconButton
            onClick={handleCloseEnq}
            size="medium"
            edge="start"
            color="inherit"
            aria-label="open drawer"
            sx={{
              float: "right",
              position: "absolute",
              right: "20px",
              top: "20px",
              zIndex: "3",
            }}
          >
            <CancelIcon />
          </IconButton>
          <div style={{ maxHeight: "550px", overflow: "auto" }}>
            <div className="row">
              <div className="col-12 mb-3">
                <h4 className="d-inline-block m-0 fw-bold text-uppercase">
                  <span className="txtred">PRODUCT</span>{" "}
                  <span className="txtdgray">ENQUIRIES</span>
                </h4>
              </div>
            </div>
            <form onSubmit={formik.handleSubmit} autoComplete="off">
              <div className="row">
                <div className="col-12 col-md-6">
                  <Autocomplete
                    disablePortal
                    id="category"
                    className="mb-3"
                    name="category"
                    getOptionLabel={(option) => option.name}
                    options={catlist}
                    // defaultValue={}
                    onChange={pcatHandle}
                    sx={{ width: "100%" }}
                    renderInput={(params) => (
                      <TextField
                        variant="standard"
                        {...params}
                        required
                        label="Select Category"
                      />
                    )}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <Autocomplete
                    disablePortal
                    id="modal"
                    className="mb-3"
                    name="modal"
                    getOptionLabel={(option) => option.name}
                    options={productData}
                    // defaultValue={}
                    onChange={modalHandle}
                    sx={{ width: "100%" }}
                    renderInput={(params) => (
                      <TextField
                        variant="standard"
                        {...params}
                        required
                        label="Select Model"
                      />
                    )}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <TextField
                    required
                    id="likeTo"
                    className="w-100 mb-3"
                    select
                    label="I would like to"
                    name="likeTo"
                    variant="standard"
                    value={formik.values.likeTo}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.likeTo && Boolean(formik.errors.likeTo)
                    }
                    helperText={formik.touched.likeTo && formik.errors.likeTo}
                  >
                    {liketoOption?.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </div>
                <div className="col-12 col-md-6">
                  <TextField
                    className="mb-3 w-100"
                    variant="standard"
                    id="cname"
                    name="cname"
                    label="Name"
                    type="text"
                    value={formik.values.cname}
                    onChange={formik.handleChange}
                    error={formik.touched.cname && Boolean(formik.errors.cname)}
                    helperText={formik.touched.cname && formik.errors.cname}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <TextField
                    required
                    className="mb-3 w-100"
                    variant="standard"
                    id="email"
                    name="email"
                    label="Email ID"
                    type="text"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    error={formik.touched.email && Boolean(formik.errors.email)}
                    helperText={formik.touched.email && formik.errors.email}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <TextField
                    required
                    variant="standard"
                    className="mb-3 w-100"
                    label="Mobile Number"
                    inputProps={{
                      maxLength: 10,
                    }}
                    id="mobile"
                    name="mobile"
                    value={formik.values.mobile}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.mobile && Boolean(formik.errors.mobile)
                    }
                    helperText={formik.touched.mobile && formik.errors.mobile}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <Autocomplete
                    disablePortal
                    id="state"
                    className="mb-3 "
                    name="state"
                    options={stateList}
                    onChange={stateChange}
                    sx={{ width: "100%" }}
                    renderInput={(params) => (
                      <TextField
                        required
                        variant="standard"
                        {...params}
                        label="Select State"
                      />
                    )}
                  />
                </div>
                <div className="col-12 col-md-6">
                  <Autocomplete
                    disablePortal
                    className="mb-3"
                    id="city"
                    name="city"
                    options={cityList}
                    onChange={cityChange}
                    sx={{ width: "100%" }}
                    renderInput={(params) => (
                      <TextField
                        required
                        variant="standard"
                        {...params}
                        label="Select City"
                      />
                    )}
                  />
                </div>
                <div className="col-12 col-md-12">
                  <TextField
                    className="mb-3 w-100"
                    variant="standard"
                    id="comments"
                    name="comments"
                    label="Comments"
                    type="text"
                    multiline
                    rows={3}
                    value={formik.values.comments}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.comments && Boolean(formik.errors.comments)
                    }
                    helperText={
                      formik.touched.comments && formik.errors.comments
                    }
                  />
                </div>
                <div className="col-md-12 col-12 mb-3">
                  <ReCAPTCHA
                    style={{ display: "inline-block" }}
                    theme="light"
                    ref={recaptchaRef}
                    sitekey={TEST_SITE_KEY}
                    onChange={onVerifyCaptcha}
                    onExpired={() => {
                      recaptchaRef.current.reset(); // here
                      setCaptchavalue("");
                    }}
                  />
                </div>
              </div>
              <Button
                color="error"
                disabled={!enabledbtn}
                variant="contained"
                className="w-100"
                type="submit"
              >
                SUBMIT
              </Button>
            </form>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default StickySidebar;
